module.exports = __webpack_public_path__ + "img/7.be43bf0b.png";